import React from 'react';
import { ReactComponent as Image2Vector } from '../Images/image2vector.svg';
import './Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-background"></div>
      <div className="hero-orb-bottom-left"></div>
      <div className="container">
        <div className="hero-content">
          <div className="hero-logo">
            <Image2Vector className="main-logo" role="img" aria-label="Victor Charles logo" />
          </div>
          <h1 className="hero-title">
            Developing <span>Better Businesses</span>
          </h1>
          <p className="hero-subtitle">
            Specialized consulting services and solutions architecture that transforms challenges into opportunities for growth, through creative problem solving and innovative technology
          </p>
        </div>
      </div>
      <div className="scroll-indicator">
        <div className="mouse"></div>
      </div>
    </section>
  );
};

export default Hero;
